import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { VerifyPasswordDTO, VerifyPasswordPayload } from '../authTypes'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useVerifyPassword = (
  options?: IOptionsUseMutation<VerifyPasswordDTO>,
) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<VerifyPasswordDTO, ErrorDetail, VerifyPasswordPayload>({
    mutationFn: authServices.verifyPassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries()

      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (
        code === ApiErrorCode.PASSWORD_INVALID ||
        code === ApiErrorCode.USER_NOT_FOUND
      ) {
        errorMessage = t('api:validationErrors.incorrectPassword')
      }

      if (options?.onError) {
        options.onError({ ...err, errorMessage, code })
      }
    },
  })
}
